import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()(() => ({
  container: {
    ...dFlex('space-between'),
    paddingBottom: 24,
    width: '100%',
  },
  closeIcon: {
    ...dFlex(),
    height: 44,
    padding: 6,
    width: 44,
  },
  link: {
    ...dFlex('initial', 'center'),
  },
  logo: {
    height: 40,
    marginTop: -15,
  },
  buttons: {
    ...dFlex(),
    gap: 8,
  },
  chainButton: {
    padding: 6,
    width: 44,
  },
  connectWallet: {
    padding: 6,
    width: 44,
  },
}));

export default useStyles;
